import { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { usePayersNameListQuery } from '@common/cache';
import { isEmpty } from 'lodash';
import { OtherInsuranceFormShape } from '../../hooks/useOtherInsuranceForm';
import { isCashPaymentType } from '../../utils';

interface UseOtherInsuranceEntryProps {
  index: number;
}

export const useOtherInsuranceEntry = ({
  index,
}: UseOtherInsuranceEntryProps) => {
  const { control, getValues, setValue } =
    useFormContext<OtherInsuranceFormShape>();

  const [payersQuery, setPayersQuery] = useState(
    () => getValues(`entries.${index}.insurance_company_name`) ?? '',
  );

  const { data = { payers: [] } } = usePayersNameListQuery({
    search: payersQuery,
  });

  const isPatientFieldValue = useWatch({
    control,
    name: `entries.${index}.subscriber.is_patient`,
  });

  const verbalConsentDate = useWatch({
    control,
    name: `entries.${index}.consent.verbal_consent_date`,
  });

  const paymentType = useWatch({
    control,
    name: `entries.${index}.payment_type`,
  });

  const isCashPayment = isCashPaymentType(paymentType);

  const isConsentGivenByRequired = !isEmpty(verbalConsentDate);

  return {
    control,
    setValue,
    payers: data.payers,
    payersQuery,
    setPayersQuery,
    isPatientFieldValue,
    isConsentGivenByRequired,
    isCashPayment,
  };
};
